<template>
  <v-layout  row wrap >

    <v-flex xs12 >
      <div class="text-xs-left subheading">Enter your street address.</div>
      <v-switch
        class="ml-1"
        v-model="isLocationOn"
        @change="fetchGeoLocation()"
        label="Use location services to autocomplete"
      ></v-switch>

      <form class="mt-2"  autocomplete="off">
        <v-text-field
          readonly
          label="Full Name"
          :value="fullName"
        ></v-text-field>

        <form autocomplete="off">
          <v-text-field
            label="Address line 1"
            v-model="addressLine1"
            v-validate="'required'"
            :error-messages="errors.collect('addressLine1')"
            data-vv-name="addressLine1"
          ></v-text-field>
        </form>

        <form autocomplete="off">
          <v-text-field
            label="Address line 2"
            v-model="addressLine2"
            data-vv-name="addressLine2"
          ></v-text-field>
        </form>

        <form autocomplete="off">
          <v-text-field
            label="City"
            v-model="city"
            v-validate="'required'"
            :error-messages="errors.collect('city')"
            data-vv-name="city"
          ></v-text-field>
        </form>

        <v-flex d-flex>

          <form autocomplete="off">
            <v-text-field
              label="Postal Code"
              v-model="postalCode"
              v-validate="'required'"
              :error-messages="errors.collect('postalCode')"
              data-vv-name="postalCode"
              type="tel"
            ></v-text-field>
          </form>

          <form autocomplete="off">
            <v-autocomplete
              v-model="selectedCountry"
              :items="countries"
              item-text="name"
              item-value="id"
              label="Select Country"
              @change="getStates()"
              v-validate="'required'"
              :error-messages="errors.collect('selectedCountry')"
              data-vv-name="selectedCountry"
            ></v-autocomplete>
          </form>
        </v-flex>

        <form autocomplete="off">

          <form autocomplete="off">
            <v-autocomplete
                v-model="selectedState"
                :items="states"
                @change="checkIfFilled"
                item-text="name"
                item-value="id"
                label="Select State"
                v-validate="'required'"
                :error-messages="errors.collect('selectedState')"
                data-vv-name="selectedState"
            ></v-autocomplete>
          </form>
        </form>

        <v-flex xs12 d-flex >
          <v-btn class="ml-0" @click="goToSignupStep(page, 'confirm-name')" color="primary">&#8592; Back</v-btn>

          <v-btn dark class="mr-0" @click="updateLocationInfo" color="green">Next &#8594;</v-btn>

        </v-flex>

      </form>
    </v-flex>

  </v-layout>
</template>

<script>
  import crypto from '@/mixins/crypto'
  import Vue from 'vue'
  import VeeValidate from 'vee-validate'
  import {mapGetters, mapMutations} from 'vuex'
  // import { Geolocation } from '@capacitor/geolocation'
  import common from '@/mixins/common'

  Vue.use(VeeValidate)
  function compare (a, b) {
    // Use toUpperCase() to ignore character casing
    const bandA = a.name.toUpperCase()
    const bandB = b.name.toUpperCase()

    let comparison = 0
    if (bandA > bandB) {
      comparison = 1
    } else if (bandA < bandB) {
      comparison = -1
    }
    return comparison
  }

  export default {
    name: 'GetLocationInfo',
    props: {
      page: {
        default: 'SignUp',
        type: String
      }
    },
    data () {
      return {
        loc: null,
        isLocationOn: false,
        isFormValidated: false,
        loading: false,
        dialog: false,
        addressLine1: '',
        addressLine2: '',
        postalCode: '',
        uname: '',
        selectedCountry: '',
        selectedCountryTxt: '',
        selectedState: '',
        selectedStateTxt: '',
        city: '',
        countries: [],
        states: [],
        e1: true,
        password: '',
        dictionary: {
          attributes: {
            email: 'E-mail Address'
          },
          custom: {
            selectedState: {
              required: () => 'Please select state'
            },
            addressLine1: {
              required: () => 'Address line1 should not be blank'
            },
            addressLine2: {
              required: () => 'Address line2 should not be blank'
            },
            city: {
              required: () => 'City should not be blank'
            },
            postalCode: {
              required: () => 'Postal code should not be blank'
            },
            selectedCountry: {
              required: () => 'Please select country'
            }
          }
        }
      }
    },
    created () {
      this.loc = {
        lat: null,
        long: null
      }
      this.getCountries()
    },
    computed: {
      ...mapGetters('registration', ['getUserDetails']),
      email () {
        return this.decryptStr()
      },
      fullName () {
        return this.getUserDetails.first_name + ' ' + this.getUserDetails.last_name
      },
      addressVerified () {
        return this.getUserDetails.address_verified
      }
    },
    mounted () {
      this.$validator.localize('en', this.dictionary)

      this.addressLine1 = this.getUserDetails.address_line1
      this.addressLine2 = this.getUserDetails.address_line2
      this.postalCode = this.getUserDetails.postal_code
      this.selectedState = this.getUserDetails.state
      this.selectedCountry = this.getUserDetails.country
      this.city = this.getUserDetails.city
      this.isLocationOn = this.getUserDetails.location_service_used
    },
    methods: {
      ...mapMutations('registration', [
        'setUser'
      ]),
      fetchGeoLocation () {
        if (this.isLocationOn) {
          this.getCurrentPosition()
        }
      },
      resetLocation () {
        this.addressLine1 = ''
        this.addressLine2 = ''
        this.postalCode = ''
        this.selectedState = ''
        this.selectedCountry = ''
        this.city = ''
      },
      async getCurrentPosition () {
        // this.$store.commit('setLoadingDialog', true, { root: true })
        // try {
        //   const pos = await Geolocation.getCurrentPosition()
        //   const lat = pos.coords.latitude
        //   const long = pos.coords.longitude
        //   this.loc = {lat, long}
        //   const key = 'AIzaSyCiOgbuS6yCGFDDJc2eqWweh_J7wmd2xqo'
        //   this.$http({
        //     url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${key}`,
        //     method: 'GET'
        //   }).then((res) => {
        //     const addressArr = res.data.results[0].address_components
        //     let addLine1 = []
        //     let addLine2 = []
        //
        //     addressArr.forEach(row => {
        //       if (row.types.includes('premise') ||
        //         row.types.includes('street_number') ||
        //         row.types.includes('plus_code') ||
        //         row.types.includes('route')
        //       ) {
        //         addLine1.push(row.long_name)
        //       }
        //
        //       if (row.types.includes('locality')) {
        //         this.city = row.long_name
        //       }
        //
        //       // if (row.types.includes('neighborhood') ||
        //       //   row.types.includes('locality') ||
        //       //   row.types.includes('sublocality')
        //       // ) {
        //       //   // addLine2.push(row.long_name)
        //       //   this.city = row.long_name
        //       // }
        //
        //       // if (row.types.includes('administrative_area_level_2')) {
        //       //   this.city = row.long_name
        //       // }
        //
        //       if (row.types.includes('postal_code')) {
        //         this.postalCode = row.long_name
        //       }
        //
        //       // State never filled up for RI
        //       if (row.types.includes('administrative_area_level_1')) {
        //         this.selectedStateTxt = row.long_name
        //       }
        //
        //       if (row.types.includes('country')) {
        //         this.selectedCountryTxt = row.long_name
        //       }
        //     })
        //     this.addressLine1 = addLine1.join(', ')
        //     this.addressLine2 = addLine2.join(', ')
        //     this.$store.commit('setLoadingDialog', false, { root: true })
        //   })
        // } catch (err) {
        //   this.$store.commit('setLoadingDialog', false, { root: true })
        // }
      },
      checkIfFilled () {
        this.$validator.validateAll().then((result) => {
          this.isFormValidated = result
        })
      },
      getCountries () {
        this.$http({
          url: process.env.API_URL + '/ws/userservice/country',
          method: 'GET'
        }).then((res) => {
          this.countries = res.data.countries
        })
      },
      setSelectedState () {
        if (this.selectedStateTxt && this.states) {
          const selectedState = this.states.filter(state => state.name === this.selectedStateTxt)
          this.selectedState = selectedState[0]['id']
        }
      },
      setSelectedCountry () {
        if (this.selectedCountryTxt && this.countries) {
          const selectedCountry = this.countries.filter(country => country.name === this.selectedCountryTxt)
          this.selectedCountry = selectedCountry[0]['id']
        }
      },
      getStates () {
        console.log('GET SATES', this.selectedStateTxt)
        if (!this.selectedCountry) return

        this.$http({
          url: process.env.API_URL + '/ws/userservice/country/' + this.selectedCountry + '/state',
          method: 'GET'
        }).then((res) => {
          this.states = res.data.states.sort(compare)
          this.setSelectedState()
        })
      },
      updateLocationInfo () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            const countryName = this.countries.find(country => country.id === this.selectedCountry).name
            const stateName = this.states.find(state => state.id === this.selectedState).name
            this.setUser({
              ...this.getUserDetails,
              address_line1: this.addressLine1,
              address_line2: this.addressLine2,
              city: this.city,
              postal_code: this.postalCode,
              state: this.selectedState,
              country: this.selectedCountry,
              address_verified: true,
              country_name: countryName,
              state_name: stateName,
              location_service_used: this.isLocationOn
            })
            const step = this.page === 'SignUp' ? 'confirm-pwd' : 'update-profile'
            this.$router.push({name: this.page, params: {step}})
          }
        })
      }
    },
    watch: {
      selectedCountry () {
        this.getStates()
      },
      selectedCountryTxt () {
        this.setSelectedCountry()
      }
    },
    mixins: [crypto, common]
  }
</script>



// WEBPACK FOOTER //
// src/components/views/sign-up/GetLocationInfo.vue